
define('text!presentation/common/callFlow/views/autoAttendantSubMenuCallFlow.html',[],function () { return '<div class="call-flow-list__submenu" data-bind="with: subMenuCallFlow">\n    <!-- ko compose: { model: $root.callFlowViewModel, activate: false } --><!--/ko-->\n</div>\n';});

